import api from '../../services/api';

/**
 * A page of the shipments that need attention.
 *
 * Same scope and same predicates as the dashboard's card — it is the same
 * manager on the other side — so the count on the card and the rows here are
 * two views of one query, not two answers to a similar question.
 *
 * @param {object} params - `start_date`, `end_date`, `company`, `reason`,
 *   `page`, `page_size`
 */
export const getAttentionPageRequest = (params) => {
  return api.get('api/deliveries/attention/', { params });
};

/**
 * Asks the courier for tracking numbers, in bulk.
 *
 * Takes **delivery ids** — the opposite currency to `change_status`, which
 * takes order ids for the very same shipments — and answers
 * `{success: [...], failed: [...]}`, so a partial result is expected, not an
 * exception.
 *
 * This is the endpoint the dead "Obtener tracking" item in Envíos was supposed
 * to call: there the item hangs off `delivery_status === 'no_tracking'`, a
 * value that is not among the nineteen statuses, so it never renders.
 *
 * @param {number[]} deliveryIds
 */
export const requestTrackingNumbersRequest = (deliveryIds) => {
  return api.post('api/set-tracking-number/', { data: deliveryIds });
};
